/** @format */

const template = `
<div ng-if="$ctrl.yearRange">
  <sis-tooltip
    [append-to-body]="true"
    [tooltip-enabled]="!$ctrl.disableTooltip && $ctrl.curriculumPeriods.length > 0"
    tooltip-placement="top"
    tooltip-wide>
    <span
      class="sis-tooltip-trigger-content"
      ng-class="{'tooltip-trigger-word': !$ctrl.disableTooltip && $ctrl.curriculumPeriods.length > 0}"
      >{{$ctrl.yearRange | yearRange}}</span
    >
    <div class="sis-tooltip-content">
      <span translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.COURSE_UNIT_CURRICULUM_PERIODS</span>
      <span ng-repeat="period in $ctrl.curriculumPeriods track by period.id"
        >{{$first ? '' : ', '}}{{period.abbreviation | localizedString}}</span
      >
    </div>
  </sis-tooltip>
</div>
`;
export default template;
